export const TTS_SERVICES = [
    { value: 'google',     text: 'Google'     },
    { value: 'deepgram',   text: 'Deepgram'   },
    { value: 'cartesia',   text: 'Cartesia'   },
    { value: 'elevenlabs', text: 'ElevenLabs' },
    { value: 'gradium',    text: 'Gradium'    },
]

export const TTS_PARAMS = {
    google: [
        { key: 'language', label: 'Language', type: 'text', default: 'fr-FR' },
        { key: 'voice', label: 'Voice', type: 'text', default: 'fr-FR-Standard-A' },
    ],
    deepgram: [
        { key: 'voice', label: 'Voice', type: 'text', default: '' },
        { key: 'api_key', label: 'API Key', type: 'text', default: '' },
        { key: 'stream', label: 'Stream', type: 'dropdown', options: ['false', 'true'], default: 'false' },
        { key: 'label', label: 'Label', type: 'text', default: 'custom' },
    ],
    cartesia: [
        { key: 'voiceId', label: 'Voice ID', type: 'text', default: '' },
        { key: 'model', label: 'Model', type: 'dropdown', options: ['sonic', 'sonic-preview', 'sonic-multilingual', 'sonic-3', 'sonic-turbo'], default: 'sonic-multilingual' },
        { key: 'api_key', label: 'API Key', type: 'text', default: '' },
        { key: 'speed', label: 'Speed (0.6-1.5)', type: 'number', default: 1.0 },
        { key: 'volume', label: 'Volume (0.5-2.0)', type: 'number', default: 1.25 },
        { key: 'emotion', label: 'Emotion', type: 'text', default: 'neutral' },
        { key: 'language', label: 'Language', type: 'text', default: '' },
        { key: 'stream', label: 'Stream', type: 'dropdown', options: ['false', 'true'], default: 'false' },
        { key: 'label', label: 'Label', type: 'text', default: 'custom' },
        { key: 'pronunciationDictId', label: 'Pronunciation Dict ID', type: 'text', default: '' },
    ],
    gradium: [
        { key: 'voiceId',         label: 'Voice ID',                    type: 'text',     default: '' },
        { key: 'model',           label: 'Model',                       type: 'text',     default: 'default' },
        { key: 'api_key',         label: 'API Key',                     type: 'text',     default: '' },
        { key: 'paddingBonus',    label: 'Speed (-4.0 faster → +4.0 slower)', type: 'number', default: 0.0 },
        { key: 'temp',            label: 'Temperature (0.0-1.4)',       type: 'number',   default: 0.7 },
        { key: 'cfgCoef',         label: 'CFG Coef (1.0-4.0)',         type: 'number',   default: 2.0 },
        { key: 'language',        label: 'Language (fr/en/de/es/pt)',   type: 'text',     default: '' },
        { key: 'stream',          label: 'Stream',                      type: 'dropdown', options: ['false', 'true'], default: 'false' },
        { key: 'label',           label: 'Label',                       type: 'text',     default: 'custom' },
        { key: 'pronunciationId', label: 'Pronunciation Dict ID',       type: 'text',     default: '' },
    ],
    elevenlabs: [
        { key: 'voice', label: 'Voice ID', type: 'text', default: '' },
        {
            key: 'model_id', label: 'Model', type: 'dropdown',
            options: ['eleven_turbo_v2', 'eleven_multilingual_v2', 'eleven_flash_v2_5'],
            default: 'eleven_turbo_v2'
        },
        { key: 'api_key', label: 'API Key', type: 'text', default: '' },
        { key: 'similarity_boost', label: 'Similarity Boost (0-1)', type: 'number', default: 0 },
        { key: 'stability', label: 'Stability (0-1)', type: 'number', default: 0 },
        { key: 'style', label: 'Style (0-1)', type: 'number', default: 0 },
        { key: 'use_speaker_boost', label: 'Use Speaker Boost', type: 'dropdown', options: ['false', 'true'], default: 'false' },
        { key: 'optimize_streaming_latency', label: 'Optimize Streaming Latency (0-4)', type: 'number', default: '' },
        { key: 'stream', label: 'Stream', type: 'dropdown', options: ['false', 'true'], default: 'false' },
        { key: 'label', label: 'Label', type: 'text', default: 'custom' },
        { key: 'speed', label: 'Speed (0.7-1.2)', type: 'number', default: '' },
    ],
}
